import React from 'react'
import { ExecuteOperationOnPipe } from '@morningtrain/react-resources'
import { RefreshAuthOnPipe } from '@morningtrain/react-auth'
import { NavigateOnPipe, useRouter } from '@morningtrain/react-navigation'
import { CallbackOnPipe } from '@morningtrain/react-helpers'
import { useSpawner } from '@morningtrain/react-spawner'

export default function LogOutOnPipe () {
  const router = useRouter()
  const spawner = useSpawner()

  return (
    <>
      <ExecuteOperationOnPipe namespace='auth' resourceName='login' operationName='logout' />
      <RefreshAuthOnPipe />
      <CallbackOnPipe callback={() => {
        if (spawner && typeof spawner.clear === 'function') {
          spawner.clear()
        }
      }}
      />
      <NavigateOnPipe route={router.redirectOnLogoutRoute} />
    </>
  )
}
